/**
 * Configuration for the Limit Simulator
 * Contains all configurable parameters for the simulation
 */

import BUSINESS_CONFIG from './businessConfig';

// Net deposit limit (regulatory requirement)
export const NET_DEPOSIT_LIMITS = {
  DEFAULT: 700, // Default net deposit limit per calendar month
};

// Self-imposed deposit limits (default values)
export const DEPOSIT_LIMITS = {
  DAILY: 100,
  WEEKLY: 300,
  MONTHLY: 1000,
};

// Login/Play time limits
export const LOGIN_LIMITS = {
  DAILY: 8, // Maximum 8 hours per day
  WEEKLY: 40, // Example: 40 hours per week
  MONTHLY: 160, // Example: 160 hours per month
};

// Automatic withdrawal limit settings
export const WITHDRAWAL_LIMITS = {
  DEFAULT_MAX_BALANCE: 500,
  DEFAULT_RESERVE: 100,
};

// Simulation settings (technical, not business-editable)
export const SIMULATION = {
  WEEKS: 5,
  STARTING_BALANCE: 0,
  WIN_PROBABILITY: 0.5, // 50/50 chance of winning
  WIN_MULTIPLIER: 1, // Win amount equals bet amount
};

// UI Configuration (technical)
export const UI = {
  DEFAULT_LANGUAGE: 'nl',
  SUPPORTED_LANGUAGES: ['en', 'nl'],
  CURRENCY: 'EUR',
  CURRENCY_SYMBOL: '€',
};

// Analytics configuration (technical)
export const ANALYTICS = {
  ENABLED: true,
  // GA4 measurement ID will be added when available
  GA_MEASUREMENT_ID: '',
};

// Export business config for convenience (optional)
export { BUSINESS_CONFIG }; 